import { render } from "./ReturnItem.vue?vue&type=template&id=19dd00b5"
import script from "./ReturnItem.vue?vue&type=script&lang=js"
export * from "./ReturnItem.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ReturnItem.vue?vue&type=style&index=0&id=19dd00b5&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__